import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class UserName extends PrimitiveValueObject<string> {
  static create(value: string): UserName {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new UserName(value);
  }
}
